import React from 'react';
import HeadingXSmall from "../../../../ui/Typography/titles/HeadingXSmall";
import styles from '../../AddToBagVerification.module.scss';
const ErrorContent = ({ labels }) => {
    return (React.createElement(HeadingXSmall, { Tag: "p", className: styles.errorContent, center: true }, labels === null || labels === void 0 ? void 0 : labels.errorLabel));
};
export default ErrorContent;
//# sourceMappingURL=ErrorContent.js.map